<template>
  <f7-page>
    <div>
      <f7-navbar
        sliding
        :style="appTheme"
        :title="$t('common.detail')"
      >
        <f7-nav-right>
          <f7-link @click="NavigateBack()">
            <img
              alt="iconBack"
              src="@/static/icons/back.svg"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCInformacionLineaPunto
        class="navbar-amarillo-1"
        :activo="activo"
      />

      <div>
        {{ $t('production.dump.retrieve.view.labels.logisticUnit', { text: activarRecuperadoPorPartida }) }}
        {{ $t('production.dump.retrieve.view.labels.batch', { text: activarRecuperadoPorUL }) }}

        <PCRecuperarMercanciavolcadaVistaPartida :id-partida="partidaActiva.Id" />
        <PCRecuperarMercanciavolcadaVistaUL :unidad-logistica="unidadLogisticaActiva" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import PCRecuperarMercanciavolcadaVistaPartida from '@/components/production/traceability/PCRecuperarMercanciaVolcadaVistaPartida.vue';
import PCRecuperarMercanciavolcadaVistaUL from '@/components/production/traceability/PCRecuperarMercanciaVolcadaVistaUL.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmRetrieveOverturnedMerchandiseView',
  components: {
    PCInformacionLineaPunto,
    PCRecuperarMercanciavolcadaVistaPartida,
    PCRecuperarMercanciavolcadaVistaUL,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    unidadLogistica: {
      type: Object,
      default: null,
    },
    partida: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      MODOSFRM: { PARTIDA: 'p', UNIDADLOGISTICA: 'ul' }, // Controla el modo de recuperado
      modofrm: '',
      partidaActiva: '',
      unidadLogisticaActiva: null,
      activarRecuperadoPorPartida: false,
      activarRecuperadoPorUL: false,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, ['unidadLogisticaSeleccionada']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-orange)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    unidadLogistica() {
      this.unidadLogisticaActiva = this.unidadLogistica; // Unidad Logistica pasada como parametro.
      this.activarRecuperadoPorPartida = false;
      this.establecerMododDeFrm();
    },
    partida() {
      this.partidaActiva = this.partida; // Partida pasada como parametro
      this.activarRecuperadoPorUL = true;
      this.establecerMododDeFrm();
    },
    activo(val) {
      if (val) {
        this.ActivarListener();
      } else {
        this.RestablecerValoresDelFrm();
        this.DesactivarListener();
      }
    },
  },

  mounted() {
    this.unidadLogisticaActiva = this.unidadLogisticaSeleccionada;
    this.establecerMododDeFrm();
    this.activarRecuperadoPorUL = true;
  },
  methods: {
    NavigateBack() {
      f7.views.main.router.back();
    },
    ActivarListener() {
      Log(this, this.ActivarListener.name);
      eventBus.on('PCRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado', () => {
        this.MovimientoRealizado();
      });
    },
    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('PCRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado');
    },
    /** Método establecerMododDeFrm */
    establecerMododDeFrm() {
      Log(this, this.establecerMododDeFrm.name);
      if (this.unidadLogistica !== null) {
        this.modofrm = this.MODOSFRM.UNIDADLOGISTICA;
        return;
      }
      if (this.partida !== null) {
        this.modofrm = this.MODOSFRM.PARTIDA;
      }
    },
    /** Método RestablecerValoresDelFrm */
    RestablecerValoresDelFrm() {
      Log(this, this.RestablecerValoresDelFrm.name);
      this.partidaActiva = '';
      this.unidadLogisticaActiva = '';
    },

    VerDetalleVolcado(idVolcado) {
      Log(this, this.VerDetalleVolcado.name);
      this.actionsSeleccionRecuperado = true;
      [this.seleccionVolcado] = this.volcados.filter((v) => v.Id === idVolcado);
      Log(this.seleccionVolcado);
    },
    /** Método MovimientoRealizado */
    MovimientoRealizado() {
      Log(this, this.MovimientoRealizado.name);
      eventBus.emit('movimientoRealizado'); // Llama al resto de componentes para su actualización.
      this.CerrarPopup();
    },
    /** Método CerrarPopup */
    CerrarPopup() {
      Log(this, this.CerrarPopup.name);
      f7.popup.close('.elementosRecuperablesDeLectura-popup', true);
    },
  },
};
</script>

<style scoped>
.div-horaRegistroMovimiento {
  background: #009ba621;
  border: 1px solid #009ba6;
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #009ba6;
  font-size: 3.5vw;
  min-height: 25px;
  max-width: 100px;
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-size: 5vw;
}

.div-contenidofrmRecuperarMercanciaVolcadaVista {
  margin: 20px;
}

.span-ttlElemento {
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
}

.span-textoElemento {
  color: #009ba6;
  font-size: 14px;
  font-weight: 500;
}

.div-informacionDelDetalle {
  margin-top: 21px;
}

.row {
  padding-bottom: 15px;
}
</style>
